import { gql, useMutation } from "@apollo/client";

export const CREATE_FISCAL_YEAR_MUTATION = gql`
  mutation CreateFiscalYear($fiscalYear: FiscalYearInput!) {
    createFiscalYear(fiscalYear: $fiscalYear) {
      fiscalYearId
      year
      startDate
    }
  }
`;

export const useCreateFiscalYear = () => {
  const [createFiscalYear] = useMutation(CREATE_FISCAL_YEAR_MUTATION);

  return { createFiscalYear };
};
